<template>
  <v-row class="align-center">
    <v-col cols="3" class="subtitle-2">Commission</v-col>
    <v-col>
      <div v-if="value" class="d-flex align-center">
        <span class="mr-2 text-capitalize" v-if="value.enabled === false">No</span>
        <f-percent v-if="value.enabled" outlined hide-details dense :value="value.value" @input="updateValue($event)" />
        <v-btn icon x-small @click="clear">
          <v-icon small>clear</v-icon>
        </v-btn>
      </div>
      <div v-else>
        <v-btn
          v-for="opt in ['yes', 'no']"
          :key="opt"
          x-small
          class="mx-1 cyoa-btn"
          color="grey lighten-1"
          @click="add(opt)"
        >
          {{ opt }}
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    // Expecting { enabled: boolean, value?: number }
    value: Object,
  },
  methods: {
    add(opt) {
      const payload = opt === "no" ? { enabled: false } : { enabled: true, value: 0 };
      this.$emit("input", payload);
    },
    updateValue(newPercent) {
      this.$emit("input", { ...this.value, value: newPercent });
    },
    clear() {
      this.$emit("input", null);
    },
  },
};
</script>
